import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AuthenticationControllRBAC = {
  pageID: '7a03858ff1028cdd3786f83d4f1f03e8',
  elementID: {
    ViewList: '4f38f22de3ae0cfd653b6b8b3ec2cefe',
    EndSession: '48f7000bfea93450d7b02abc8ab4e155',
  },
} as const

export const useRBACAuthenticationControllRBACPage = createUseRBAC(
  AuthenticationControllRBAC.elementID,
)

export type UseRBACAuthenticationControllPageType = ReturnType<
  typeof useRBACAuthenticationControllRBACPage
>
